import { Component } from '@angular/core';
import { ConstantService } from '../../services/constant.service';
import { UtilService } from '../../services/util.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserSessionService } from '../../services/user-session.service';
import { CommonService } from '../../services/common.service';
import { FinBoxStatusReq, VendorStatusReq } from '../../models/request.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';

@Component({
  selector: 'app-timing-loader',
  imports: [],
  templateUrl: './timing-loader.component.html',
  styleUrl: './timing-loader.component.less'
})
export class TimingLoaderComponent {
  session_id: string = '';
  time_Interval: any;
  min: any = 2
  sec : any = 30
  
    timer: number = 56;
    isSuccess!:boolean

  constructor(
      private constantService: ConstantService,
      private utilService: UtilService,
      private datePipe: DatePipe,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private userSessionService : UserSessionService,
      private commonService : CommonService,
      private _snackbar: MatSnackBar
  ) {
      this.activatedRoute.queryParams?.subscribe((params: any) => {
          if (params.session_id) {
              this.session_id = params.session_id;
              this.isSuccess = params.success
              this.getVendorStatus(params.success, params.session_id);
          }
      });
  }

  ngOnInit(): void {
      this.time_Interval = setInterval(() => {
          this.sec--;
          if (this.sec % 18 == 0) {
              this.getVendorStatus(this.isSuccess, this.session_id);
          }
        if (this.min == 0 && this.sec == 0) {
          this.min = '00';
          this.sec = '00';
          clearInterval(this.time_Interval);
          }else if (this.sec == 0) {
            this.min--;
            this.sec = 59;
        }
      }, 1000);
  }

  async getVendorStatus(isSuccess: boolean, session_id: string) {
      const appSource: string  = this.userSessionService.getUserSessionData().appSource;
      const clientCode: string  =  this.userSessionService.getUserSessionData().clientCode;
      const salarySlab: any = JSON.parse(localStorage.getItem('salarySlab') || '');
    //   const parameter = clientCode + appSource + session_id + salarySlab.ammout + this.utilService.checkSumDate;
      const vendorType = sessionStorage.getItem('vendorType') || ''
      const parameter = clientCode + appSource + this.userSessionService.getUserSessionData().ip + session_id + salarySlab.ammout + vendorType + false + this.utilService.checkSumDate;
      const finBoxStatusReq :VendorStatusReq = {
        ipAddress: this.userSessionService.getUserSessionData().ip,
        appSource: appSource,
        checkSumValue: this.utilService.GenerateCheckSum(parameter),
        clientCode: clientCode,
        incomeSlab: salarySlab.ammout,
        isNameMatch: false,
        sessionId: session_id,
        isLastAttempt: this.min == '00' && this.sec == '00'? true : false,
        isFinboxSessionSuccess: vendorType=="FINBOX" ? true : false,
        vendorType: vendorType,
        vendorRedirectPayload : sessionStorage.getItem('ecresParam') || ''
      };

      this.commonService.getVendorStatus(finBoxStatusReq).subscribe({next:(response)=>{
        const status = response.status;
        if (status == 1) {
           this.router.navigateByUrl('/derivative/successfull-request');
        } else if (status == 0 || status == 2 || status == 3) {
            this.router.navigate(['/derivative/missing-details'], {
                queryParams: { session_id: session_id, response: JSON.stringify(response.data) }
        });
        }
      },error:(err)=>{
        const status = err.error.status
        if (status == 0 || status == 2 || status == 3 || status == 8 ) {
            this.router.navigate(['/derivative/missing-details'], {
                queryParams: { session_id: session_id, response: JSON.stringify(err.error) }
        });
    }
    else if (status == 6 || status == 7 ||  status == 9) {
        this._snackbar.openFromComponent(SnackbarComponent, {
            data: [err.error.message],
            duration: this.constantService.snackBarDuration,
            panelClass: ['failed-popup']
        });
        this.router.navigateByUrl('/derivative/fail-page');
        }
    }})
  }

  ngOnDestroy() {
      clearInterval(this.time_Interval);
  }
}